import { ShareIcon } from "@/Icons/Share";
import { useIsOverflowing } from "@/api/hooks/useIsOverflowing";
import InfoPopup from "@/components/InfoPopup/InfoPopup";

import { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";

import { kebabCase } from "lodash";

type TooltipContent = Omit<ComponentProps<typeof InfoPopup>, "width">;
export interface CardInfoProps {
  heading: string;
  value?: string;
  tooltip?: TooltipContent;
  link?: string;
}

export const CardInfo: React.FC<CardInfoProps> = ({
  heading,
  value,
  tooltip,
  link,
}) => {
  const { ref, isOverflow } = useIsOverflowing<HTMLDivElement>();

  const overflowTooltipId = isOverflow ? kebabCase(value) : undefined;

  return (
    <div>
      <div className="font-dm-sans mb-0.5 text-black">
        {heading}
        {tooltip && (
          <InfoPopup
            width="350px"
            size={15}
            className="ml-1 inline-block align-baseline"
            {...tooltip}
          />
        )}
      </div>
      <p
        data-tooltip-id={overflowTooltipId}
        ref={ref}
        title={value}
        className="group font-dm-sans max-w-full items-center gap-2 overflow-hidden text-xl font-medium text-ellipsis text-black xl:max-w-[calc(100%-150px)] 2xl:max-w-full"
      >
        {value || "---"}
        {link && (
          <Link className="underline" to={link} target="_blank">
            <ShareIcon width={16} height={16} />
          </Link>
        )}
      </p>
      {isOverflow && <Tooltip id={overflowTooltipId} content={value} />}
    </div>
  );
};
